export default {
    h1: {
        fontWeight: 500,
        fontSize: 35,
        letterSpacing: '-0.24px',
    },
    h2: {
        fontWeight: 500,
        fontSize: 29,
        letterSpacing: '-0.24px',
    },
    h3: {
        fontWeight: 500,
        fontSize: 24,
        letterSpacing: '-0.06px',
    },
    h4: {
        fontWeight: 500,
        fontSize: 20,
        letterSpacing: '-0.06px',
    },
    h5: {
        fontWeight: 500,
        fontSize: 16,
        letterSpacing: '-0.05px',
    },
    h6: {
        fontWeight: 500,
        fontSize: 14,
        letterSpacing: '-0.05px',
    },
    subtitle1: {
        fontWeight: 600,
        fontSize: '1rem',
        letterSpacing: '-0.05px',
    },
    body1: {
        fontWeight: 400, // taken from default theme
        fontSize: '0.8125rem', // 13px
        letterSpacing: '-0.05px',
    },
    body2: {
        fontWeight: 400, // taken from default
        fontSize: '0.75rem', // 12px
        letterSpacing: '-0.05px',
    },
    overline: {
        fontWeight: 500,
    },
};
//# sourceMappingURL=typography.js.map